import React, { useContext, useState, useEffect, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import BigNumber from 'bignumber.js'
import { Link } from 'react-router-dom'
import { Text } from 'rebass'
import { Card } from '../../../components/bakery/styleds'
import { ButtonPrimary } from '../../../components/Button'
import { Farm } from '../../../contexts/Farms'
import { BIGNUMBER_FMT } from '../../../constants/bakery'
// import { Contract } from 'web3-eth-contract'

import { MINTTOKEN } from '../../../constants/bakery'
import { useActiveWeb3React } from '../../../hooks'

import useYam from '../../../hooks/bakery/useYam'
import {
  getEth2MasterPoolInfoMap,
  getEth2MasterContract,
  getTenBakeBLPContract,
  getTenContract,
  getTenMasterAddress,
  getAethMasterPoolInfoMap,
  getWSoteBakeBLPContract,
  getWSOTEContract,
  getSushiContract,
  getBRYBakeBLPContract,
  getBRYContract,
  getPCWSBakeBlpContract,
  getPCWSContract,
  getBakeWarBlprContract,
  getWarContract,
  getMxContract,
  getBakeMxBlPrContract,
  getBakeAliceBlpContract,
  getAliceContract,
  getSoccerBakeBlpContract,
  getSoccerContract,
  getXDittoContract,
  getXDittoBnbBlpContract,
  getTctBusdBlpContract,
  getTctContract,
  getBusdContract,
  getWethContract,
  getTkoContract,
  getTkoBakeBlpContract,
  getTsaBakeBlpContract,
  getTsaContract,
  getTlmBakeBlpContract,
  getTlmContract,
  getPokerBnbBlpContract,
  getPokerContract,
  getCarBnbBlpContract,
  getCarContract,
  getTlmBnbBlpContract,
  getDoggyBnbBlpContract,
  getDoggyContract,
  getBarkContract,
  getBondlyBnbBLpContract,
  getBondlyContract,
  getBarkDoggyBLpContract,
  getTokauBnbBlpContract,
  getTokauContract,
  // getLevBnbBlpContract,
  // getLevContract,
  getGatBnbBlpContract,
  getGatContract,
  getPetBnbBlpContract,
  getPetContract,
  getWsgBnbBlpContract,
  getDogoBnbBlpContract,
  getWsgContract,
  getDogoContract,
  getWeaponBnbBlpContract,
  getWeaponContract,
  getBakeBnbBlpContract,
  getBusdBnbBlpContract,
  getTokenEarned,
  harvest,
  getStaked,
  getMasterChef2Contract,
  getBnrgContract,
  getBnrgBnbBlpContract,
  getEggBnbBlpContract,
  getEggContract,
  getKalataBnbBlpContract,
  getKalataContract,
  getDonBnbBlpContract,
  getDonContract,
  getNtContract,
  getNtBnbBlpContract,
  getMoniBnbBlpContract,
  getMoniContract,
  getKxaBnbBlpContract,
  getKxaContract,
  getNblBnbBlpContract,
  getNblContract
} from '../../../sushi/utils'
import { getFullDisplayBalance } from '../../../utils/bakery/formatBalance'
import useInterval from '../../../hooks/useInterval'

// hook
import useFarms from '../../../hooks/bakery/useFarms'
import useAllStakedValue, { StakedValue } from '../../../hooks/bakery/useAllStakedValue'
import useBlock from '../../../hooks/bakery/useBlock'
import useBlockNum from '../../../hooks/bakery/useBlockNum'
import useBlockNum2 from '../../../hooks/bakery/useBlockNum2'
import useNumPool from '../../../hooks/bakery/useNumPool'
import { useLpTokenPrice, usePrice } from '../../../hooks/usePrice'
import useBalanceOf from '../../../hooks/useBalanceOf'

const Bakev2 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 894px;
  margin-bottom: 40px;
  font-family: Yuanti SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 90%;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 90%;
    flex-direction: column;
  `}
`

const Harvest = styled.div`
  display: flex;
  padding: 10px 20px;
  border-radius: 10px;
  align-items: center;
  background:  ${({ theme }) => theme.bsBg10};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 90%;
  `}
`
const V2harvest = styled(Text)`
  white-space: nowrap;
  width: auto;
  color: ${({ theme }) => theme.bsText2};
  margin-left: 10px !important;
  font-size: 13px;
  font-weight: 700;
`
const V2Sum = styled(Text)`
  margin-left: 10px !important;
  white-space: nowrap;
  width: auto;
  font-size: 24px;
  font-weight: 400;
  font-family: Baloo Da;
`
const V2Text = styled(Text)`
  margin-left: 10px !important;
  white-space: nowrap;
  width: auto;
  font-size: 16px;
  font-weight: 700;
  color:  ${({ theme }) => theme.bsText7};
`

const ButtonHarvest = styled(ButtonPrimary)`
  height: 30px;
  line-height: 30px;
  padding: 0px;
  margin-left: 20px;
  width: 100px;
  font-size: 14px;
`

const StakeOnly = styled.div`
  display: flex;
  padding: 10px 20px;
  padding-left: 0px;
  border-radius: 10px;
  align-items: center;
  justify-content:flex-end;
  background:  ${({ theme }) => theme.bsBg10};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 90%;
    margin-top: 10px;
  `}
  img{
    margin-left: 10px;
    cursor: pointer;
  }
`

const ListWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 894px;
  cursor: pointer;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    justify-content: space-around;
    align-items: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    align-items: center;
    justify-content: space-around;
    width: 90%;
  `}
`
const CurrencyCard = styled(Card)<{ showBorder: boolean; isCover: boolean; isEndedNft: boolean }>`
  position: relative;
  background-repeat: no-repeat;
  background-position: top right;
  background-size: ${({ isCover }) => (isCover ? 'cover' : '')};
  width: 282px;
  margin-bottom: 24px;
  padding: 24px;
  border: 2px solid
    ${({ theme, showBorder, isCover }) => (showBorder ? theme.primary1 : isCover ? 'none' : 'transparent')};
  color: ${({ theme }) => theme.bsText3};
  &:not(:nth-child(3n)) {
    margin-right: 23px;
  }
  &:hover {
    box-shadow: ${({ theme }) =>
      theme.darkMode ? '0px 2px 10px rgba(22, 16, 13, 0.48)' : '0px 2px 10px rgba(171, 133, 115, 0.16)'};
  }

  &:before {
    content: 'Ended';
    width: 94px;
    height: 40px;
    line-height: 40px;
    background: #d6a485;
    position: absolute;
    top: 16px;
    left: 0px;
    z-index: 11;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    font-family: Baloo Da;
    color: #fff;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 6px 10px rgb(0 0 0 / 20%);
    display: ${({ isEndedNft }) => (isEndedNft ? 'block' : 'none')};
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    &:not(:nth-child(3n)) {
      margin-right: 0;
    }
  `}
`
const HighlightFlag = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 75px;
  height: 75px;
  background: linear-gradient(
    45deg,
    transparent 0%,
    transparent 50%,
    ${({ theme }) => theme.primary1} 51%,
    ${({ theme }) => theme.primary1} 100%
  );
  border-top-right-radius: 20px;
`
const IconStar = styled.img`
  position: absolute;
  top: 10px;
  right: 10px;
`
const CurrencyIcon = styled.div`
  text-align: center;
`
const CurrencySymbol = styled.div`
  font-family: Baloo Da;
  color: ${({ theme }) => theme.bsText4};
  text-align: center;
  margin-bottom: 24px;
  white-space: nowrap;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    & > div {
      font-size: 26px;
    }
  `}
`
const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`
const DetailVal = styled.div`
  min-height: 27px;
  color: ${({ theme }) => theme.bsText4};
  margin-top: -3px;
  max-width: 195px;
`
const SelectBtn = styled(ButtonPrimary)`
  font-family: Baloo Da;
  margin: 32px auto 0;
  padding: 6px 16px;
`
const SelectTenBtn = styled(ButtonPrimary)`
  position: relative;
  font-family: Baloo Da;
  margin: 32px auto 0;
  padding: 6px 16px;
  background-color: #da4550;
  border: 2px solid #2a3567;
  &:hover {
    background-color: #da4550;
  }
`
const IconBtn = styled.img`
  position: absolute;
`
const BtnBox = styled.div`
  position: relative;
`
const HelmetImg = styled.img<{ bottom?: string }>`
  position: absolute;
  bottom: ${({ bottom }) => (bottom ? bottom : '10px')};
  display: inline-block;
  left: 0;
  right: 0;
  margin: 0 auto;
`
const Nothing = styled.div`
  display: block;
  text-align: center;
  width: 100%;
`

interface FarmWithStakedValue extends Farm, StakedValue {
  apy: BigNumber | null
  bakeRoi?: any
  bethRoi?: any
  ankrRoi?: any
  onxRoi?: any
  isNull?: any
}

const FarmCards = ({ tokenName }: { tokenName: string }) => {
  const theme = useContext(ThemeContext)
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const [ethInfo, setEthInfo] = useState<any>()
  const [aethInfo, setAethInfo] = useState<any>()

  const [bakeFarms] = useFarms()
  const [bakeV2Farms] = useFarms(MINTTOKEN.BAKEV2)
  const [newFarms] = useFarms(MINTTOKEN.ALLNEW)
  const [endedFarms] = useFarms(MINTTOKEN.ENDED)
  const [otherFarms] = useFarms(MINTTOKEN.OTHERS)
  const [allNftFarms] = useFarms(MINTTOKEN.ALLNFT)
  const [petFarms] = useFarms(MINTTOKEN.PET)
  const [bPetFarms] = useFarms(MINTTOKEN.BPET)
  const [weaponFarms] = useFarms(MINTTOKEN.WEAPON)
  const [bestFarms] = useFarms(MINTTOKEN.BEST)
  const [helmetFarms] = useFarms(MINTTOKEN.HELMETNFT)
  const [seascapeNftFarms] = useFarms(MINTTOKEN.SEASCAPENFT)
  const [tkoNftFarms] = useFarms(MINTTOKEN.TKONFT)
  const [hatNftFarms] = useFarms(MINTTOKEN.HATNFT)
  const [ethFarms] = useFarms(MINTTOKEN.ETH2MASTER)
  const [aethAndethFarms] = useFarms(MINTTOKEN.AETHANDETH2)
  const [aethFarms] = useFarms(MINTTOKEN.AETHMASTER)
  const [springFarms] = useFarms(MINTTOKEN.TEN)
  const [wsoteFarms] = useFarms(MINTTOKEN.WSOTE)
  const [shieldFarms] = useFarms(MINTTOKEN.SHIELD)
  const [bryFarms] = useFarms(MINTTOKEN.BRY)
  const [bakeStakingFarms] = useFarms(MINTTOKEN.BAKESTAKING)
  const [defi100Farms] = useFarms(MINTTOKEN.DEFI100)
  const [defi100OLDFarms] = useFarms(MINTTOKEN.DEFI100OLD)
  const [bananaFarms] = useFarms(MINTTOKEN.BANANA)
  const [pcwsFarms] = useFarms(MINTTOKEN.PCWS)
  const [warFarms] = useFarms(MINTTOKEN.WAR)
  const [war2Farms] = useFarms(MINTTOKEN.WAR2)
  const [dieselFarms] = useFarms(MINTTOKEN.DIESEL)
  const [mxFarms] = useFarms(MINTTOKEN.MX)
  const [aliceFarms] = useFarms(MINTTOKEN.ALICE)
  const [aliceNftFarms] = useFarms(MINTTOKEN.ALICENFT)
  const [bondlyNftFarms] = useFarms(MINTTOKEN.BONDLYNFT)
  const [dfyFarms] = useFarms(MINTTOKEN.DFY)
  const [gfxFarms] = useFarms(MINTTOKEN.GFX)
  const [xDittoFarms] = useFarms(MINTTOKEN.XDITTO)
  const [sactFarms] = useFarms(MINTTOKEN.SACT)
  const [pet3Farms] = useFarms(MINTTOKEN.PET3)
  const [hyfiFarms] = useFarms(MINTTOKEN.HYFI)
  const [ginuFarms] = useFarms(MINTTOKEN.GINU)
  const [levFarms] = useFarms(MINTTOKEN.LEV)
  const [bondlyFarms] = useFarms(MINTTOKEN.BONDLY)
  const [tctFarms] = useFarms(MINTTOKEN.TCT)
  const [tkoFarms] = useFarms(MINTTOKEN.TKO)
  const [tkonftStakeFarms] = useFarms(MINTTOKEN.TKONFTSTAKE)
  const [bmoncnftStakeFarms] = useFarms(MINTTOKEN.BMONCNFTSTAKE)
  const [bmmnftStakeFarms] = useFarms(MINTTOKEN.BMMNFTSTAKE)
  const [nftStakeFarms] = useFarms(MINTTOKEN.NFTSTAKE)
  const [oneInchBakeNftFarms] = useFarms(MINTTOKEN.ONEINCHBAKENFT)
  const [tko2Farms] = useFarms(MINTTOKEN.TKO2)
  const [bnrgFarms] = useFarms(MINTTOKEN.BNRG)
  const [tsaFarms] = useFarms(MINTTOKEN.TSA)
  const [tlmFarms] = useFarms(MINTTOKEN.TLM)
  const [xdittoNftFarms] = useFarms(MINTTOKEN.XDITTONFT)
  const [doggyTlmFarms] = useFarms(MINTTOKEN.TLM2)
  const [barkTlmFarms] = useFarms(MINTTOKEN.TLM3)
  const [tokauTlmFarms] = useFarms(MINTTOKEN.TLM4)
  const [bondly2Farms] = useFarms(MINTTOKEN.BONDLY2)
  const [toynftStakeFarms] = useFarms(MINTTOKEN.TOYNFTSTAKE)
  const [gatTlmFarms] = useFarms(MINTTOKEN.TLM5)
  const [wsgFarms] = useFarms(MINTTOKEN.WSG)
  const [dogoFarms] = useFarms(MINTTOKEN.DOGO)
  const [toyNftFarms] = useFarms(MINTTOKEN.TOYNFT)
  const [bethFarms] = useFarms(MINTTOKEN.BETHMASTER)
  const [tokauFarms] = useFarms(MINTTOKEN.TOKAU)
  const [eggFarms] = useFarms(MINTTOKEN.EGG)
  const [kalataFarms] = useFarms(MINTTOKEN.KALATA)
  const [donFarms] = useFarms(MINTTOKEN.DON)
  const [ntFarms] = useFarms(MINTTOKEN.NT)
  const [moniFarms] = useFarms(MINTTOKEN.MONI)
  const [kxaFarms] = useFarms(MINTTOKEN.KXA)
  const [nblFarms] = useFarms(MINTTOKEN.NBL)

  let farms:Array<any>
  // let masterContract
  switch (tokenName) {
    case MINTTOKEN.WSOTE:
      farms = wsoteFarms
      break
    case MINTTOKEN.SHIELD:
      farms = shieldFarms
      break
    case MINTTOKEN.ALLNEW:
      farms = newFarms
      break
    case MINTTOKEN.ENDED:
      farms = endedFarms
      break
    case MINTTOKEN.OTHERS:
      farms = otherFarms
      break
    case MINTTOKEN.ALLNFT:
      farms = allNftFarms
      break
    case MINTTOKEN.PET:
      farms = petFarms
      break
    case MINTTOKEN.BPET:
      farms = bPetFarms
      break
    case MINTTOKEN.WEAPON:
      farms = weaponFarms
      break
    case MINTTOKEN.BEST:
      farms = bestFarms
      break
    case MINTTOKEN.HELMETNFT:
      farms = helmetFarms
      break
    case MINTTOKEN.HATNFT:
      farms = hatNftFarms
      break
    case MINTTOKEN.SEASCAPENFT:
      farms = seascapeNftFarms
      break
    case MINTTOKEN.TKONFT:
      farms = tkoNftFarms
      break
    case MINTTOKEN.ETH2MASTER:
      farms = ethFarms
      break
    case MINTTOKEN.TEN:
      farms = springFarms
      break
    case MINTTOKEN.AETHANDETH2:
      farms = aethAndethFarms
      break
    case MINTTOKEN.AETHMASTER:
      farms = aethFarms
      break
    case MINTTOKEN.BRY:
      farms = bryFarms
      break
    case MINTTOKEN.BAKESTAKING:
      farms = bakeStakingFarms
      break
    case MINTTOKEN.DEFI100:
      farms = defi100Farms
      break
    case MINTTOKEN.DEFI100OLD:
      farms = defi100OLDFarms
      break
    case MINTTOKEN.BANANA:
      farms = bananaFarms
      break
    case MINTTOKEN.PCWS:
      farms = pcwsFarms
      break
    case MINTTOKEN.WAR:
      farms = warFarms
      break
    case MINTTOKEN.WAR2:
      farms = war2Farms
      break
    case MINTTOKEN.DIESEL:
      farms = dieselFarms
      break
    case MINTTOKEN.MX:
      farms = mxFarms
      break
    case MINTTOKEN.ALICE:
      farms = aliceFarms
      break
    case MINTTOKEN.ALICENFT:
      farms = aliceNftFarms
      break
    case MINTTOKEN.BONDLYNFT:
      farms = bondlyNftFarms
      break
    case MINTTOKEN.DFY:
      farms = dfyFarms
      break
    case MINTTOKEN.GFX:
      farms = gfxFarms
      break
    case MINTTOKEN.XDITTO:
      farms = xDittoFarms
      break
    case MINTTOKEN.SACT:
      farms = sactFarms
      break
    case MINTTOKEN.PET3:
      farms = pet3Farms
      break
    case MINTTOKEN.HYFI:
      farms = hyfiFarms
      break
    case MINTTOKEN.GINU:
      farms = ginuFarms
      break
    case MINTTOKEN.LEV:
      farms = levFarms
      break
    case MINTTOKEN.BONDLY:
      farms = bondlyFarms
      break
    case MINTTOKEN.TCT:
      farms = tctFarms
      break
    case MINTTOKEN.TKO:
      farms = tkoFarms
      break
    case MINTTOKEN.TKONFTSTAKE:
      farms = tkonftStakeFarms
      break
    case MINTTOKEN.BMONCNFTSTAKE:
      farms = bmoncnftStakeFarms
      break
    case MINTTOKEN.BMMNFTSTAKE:
      farms = bmmnftStakeFarms
      break
    case MINTTOKEN.TOYNFTSTAKE:
      farms = toynftStakeFarms
      break
    case MINTTOKEN.NFTSTAKE:
      farms = nftStakeFarms
      break
    case MINTTOKEN.ONEINCHBAKENFT:
      farms = oneInchBakeNftFarms
      break
    case MINTTOKEN.TKO2:
      farms = tko2Farms
      break
    case MINTTOKEN.BNRG:
      farms = bnrgFarms
      break
    case MINTTOKEN.TSA:
      farms = tsaFarms
      break
    case MINTTOKEN.TLM:
      farms = tlmFarms
      break
    case MINTTOKEN.XDITTONFT:
      farms = xdittoNftFarms
      break
    case MINTTOKEN.TLM2:
      farms = doggyTlmFarms
      break
    case MINTTOKEN.TLM3:
      farms = barkTlmFarms
      break
    case MINTTOKEN.TLM4:
      farms = tokauTlmFarms
      break
    case MINTTOKEN.BONDLY2:
      farms = bondly2Farms
      break
    case MINTTOKEN.TLM5:
      farms = gatTlmFarms
      break
    case MINTTOKEN.BAKEV2:
      farms = bakeV2Farms
      break
    case MINTTOKEN.WSG:
      farms = wsgFarms
      break
    case MINTTOKEN.DOGO:
      farms = dogoFarms
      break
    case MINTTOKEN.TOYNFT:
      farms = toyNftFarms
      break
    case MINTTOKEN.BETHMASTER:
      farms = bethFarms
      break
    case MINTTOKEN.TOKAU:
      farms = tokauFarms
      break
    case MINTTOKEN.BAKEV2:
      farms = bakeV2Farms
      break
    case MINTTOKEN.EGG:
      farms = eggFarms
      break
    case MINTTOKEN.KALATA:
      farms = kalataFarms
      break
    case MINTTOKEN.DON:
      farms = donFarms
      break
    case MINTTOKEN.NT:
      farms = ntFarms
      break
    case MINTTOKEN.MONI:
      farms = moniFarms
      break
    case MINTTOKEN.KXA:
      farms = kxaFarms
      break
    case MINTTOKEN.NBL:
      farms = nblFarms
      break
    default:
      farms = bakeFarms
  }

  const BakeStakedValue = useAllStakedValue()
  const BakeStakedValue2 = useAllStakedValue(MINTTOKEN.BAKEV2)
  const petStakedValue = useAllStakedValue(MINTTOKEN.PET)
  const currentBlock = useBlock()
  const BakeBlockNum = useBlockNum(currentBlock)
  const BakeBlockNum2 = useBlockNum2(MINTTOKEN.BAKEV2)
  const BnrgBlockNum = useBlockNum2(MINTTOKEN.BNRG)
  const DogoBlockNum = useBlockNum2(MINTTOKEN.DOGO)
  const EggBlockNum = useBlockNum2(MINTTOKEN.EGG)
  const NtBlockNum = useBlockNum2(MINTTOKEN.NT)
  const MoniBlockNum = useBlockNum2(MINTTOKEN.MONI)
  const KxaBlockNum = useBlockNum2(MINTTOKEN.KXA)
  const NblBlockNum = useBlockNum2(MINTTOKEN.NBL)
  const KalataBlockNum = useBlockNum2(MINTTOKEN.KALATA)
  const DonBlockNum = useBlockNum2(MINTTOKEN.DON)
  const petBlockNum = useBlockNum(currentBlock, MINTTOKEN.PET)
  const bPetStakedValue = useAllStakedValue(MINTTOKEN.BPET)
  const bPetBlockNum = useBlockNum(currentBlock, MINTTOKEN.BPET)
  const weaponStakedValue = useAllStakedValue(MINTTOKEN.WEAPON)
  const weaponBlockNum = useBlockNum(currentBlock, MINTTOKEN.WEAPON)
  const bestBlockNum = useBlockNum(currentBlock, MINTTOKEN.BEST)
  const bestStakedValue = useAllStakedValue(MINTTOKEN.BEST)
  const tenStakedValue = useAllStakedValue(MINTTOKEN.TEN)
  const wSoteStakedValue = useAllStakedValue(MINTTOKEN.WSOTE)
  const shieldStakedValue = useAllStakedValue(MINTTOKEN.SHIELD)
  const bryStakedValue = useAllStakedValue(MINTTOKEN.BRY)
  const pcwsStakedValue = useAllStakedValue(MINTTOKEN.PCWS)
  const defi100StakedValue = useAllStakedValue(MINTTOKEN.DEFI100)
  const bananaStakedValue = useAllStakedValue(MINTTOKEN.BANANA)
  const warStakedValue = useAllStakedValue(MINTTOKEN.WAR)
  const war2StakedValue = useAllStakedValue(MINTTOKEN.WAR2)
  const dieselStakedValue = useAllStakedValue(MINTTOKEN.DIESEL)
  const mxStakedValue = useAllStakedValue(MINTTOKEN.MX)
  const aliceStakedValue = useAllStakedValue(MINTTOKEN.ALICE)
  const dfyStakedValue = useAllStakedValue(MINTTOKEN.DFY)
  const gfxStakedValue = useAllStakedValue(MINTTOKEN.GFX)
  const xDittoStakedValue = useAllStakedValue(MINTTOKEN.XDITTO)
  const sactStakedValue = useAllStakedValue(MINTTOKEN.SACT)
  const pet3StakedValue = useAllStakedValue(MINTTOKEN.PET3)
  const hyfiStakedValue = useAllStakedValue(MINTTOKEN.HYFI)
  const ginuStakedValue = useAllStakedValue(MINTTOKEN.GINU)
  const levStakedValue = useAllStakedValue(MINTTOKEN.LEV)
  const bondlyStakedValue = useAllStakedValue(MINTTOKEN.BONDLY)
  const tctStakedValue = useAllStakedValue(MINTTOKEN.TCT)
  const tkoStakedValue = useAllStakedValue(MINTTOKEN.TKO)
  const tko2StakedValue = useAllStakedValue(MINTTOKEN.TKO2)
  const bnrgStakedValue = useAllStakedValue(MINTTOKEN.BNRG)
  const tsaStakedValue = useAllStakedValue(MINTTOKEN.TSA)
  const tlmStakedValue = useAllStakedValue(MINTTOKEN.TLM)
  const doggyStakedValue = useAllStakedValue(MINTTOKEN.TLM2)
  const barkStakedValue = useAllStakedValue(MINTTOKEN.TLM3)
  const tokauStakedValue = useAllStakedValue(MINTTOKEN.TLM4)
  const bondly2StakedValue = useAllStakedValue(MINTTOKEN.BONDLY2)
  const gatStakedValue = useAllStakedValue(MINTTOKEN.TLM5)

  // v1
  const wsgStakedValue = useAllStakedValue(MINTTOKEN.WSG)
  const dogoStakedValue = useAllStakedValue(MINTTOKEN.DOGO)
  const kalataStakedValue = useAllStakedValue(MINTTOKEN.KALATA)
  const donStakedValue = useAllStakedValue(MINTTOKEN.DON)
  const bethStakedValue = useAllStakedValue(MINTTOKEN.BETHMASTER)
  const tokau2StakedValue = useAllStakedValue(MINTTOKEN.TOKAU)
  const eggStakedValue = useAllStakedValue(MINTTOKEN.EGG)
  const ntStakedValue = useAllStakedValue(MINTTOKEN.NT)
  const moniStakedValue = useAllStakedValue(MINTTOKEN.MONI)
  const kxaStakedValue = useAllStakedValue(MINTTOKEN.KXA)
  const nblStakedValue = useAllStakedValue(MINTTOKEN.NBL)

  const bakeIndex = bakeFarms.findIndex(({ pid }) => pid === 7)
  const usdtBusdIndex = bakeFarms.findIndex(({ pid }) => pid === 10)
  const tctBusdIndex = bakeFarms.findIndex(({ pid }) => pid === 1400002)
  const busdUsdcIndex = bakeFarms.findIndex(({ pid }) => pid === 22)
  const petIndex = bakeFarms.findIndex(({ pid }) => pid === 12)
  const soccerIndex = bakeFarms.findIndex(({ pid }) => pid === 25)
  const petBakeIndex = bakeFarms.findIndex(({ pid }) => pid === 13)
  const weaponPoolPetIndex = weaponFarms.findIndex(({ pid }) => pid === 12002)
  const pokerIndex = bakeFarms.findIndex(({ pid }) => pid === 29)
  const carIndex = bakeFarms.findIndex(({ pid }) => pid === 31)
  const tokauIndex = bakeFarms.findIndex(({ pid }) => pid === 36)
  const barkDoggyIndex = bakeFarms.findIndex(({ pid }) => pid === 34)

  // v2
  const bakeIndex2 = bakeV2Farms.findIndex(({ pid }) => pid === 74)
  const bakeBusdIndex2 = bakeV2Farms.findIndex(({ pid }) => pid === 76)
  const soccerIndex2 = bakeV2Farms.findIndex(({ pid }) => pid === 60)
  const pokerIndex2 = bakeV2Farms.findIndex(({ pid }) => pid === 63)
  const carIndex2 = bakeV2Farms.findIndex(({ pid }) => pid === 66)

  // bnrg
  const bmonBusdIndex = bnrgFarms.findIndex(({ pid }) => pid === 4200001)


  useEffect(() => {
    const masterContract = getEth2MasterContract(sushi)
    getEth2MasterPoolInfoMap(masterContract).then(res => {
      setEthInfo(res)
    })
    getAethMasterPoolInfoMap(sushi).then(res => {
      setAethInfo(res)
    })
  }, [farms, sushi])

  const tenBakeBlpTenPrice = useLpTokenPrice(getTenBakeBLPContract(sushi), getTenContract(sushi))
  const tenBakeBlpBalanceOfTemMaster = useBalanceOf(getTenBakeBLPContract(sushi), getTenMasterAddress(sushi))
  const wSoteBakePrice = usePrice(getWSoteBakeBLPContract(sushi), getWSOTEContract(sushi), getSushiContract(sushi))
  const bryBakePrice = usePrice(getBRYBakeBLPContract(sushi), getBRYContract(sushi), getSushiContract(sushi))
  const pcwsBakePrice = usePrice(getPCWSBakeBlpContract(sushi), getPCWSContract(sushi), getSushiContract(sushi))
  const warBakePrice = usePrice(getBakeWarBlprContract(sushi), getWarContract(sushi), getSushiContract(sushi))
  const mxBakePrice = usePrice(getBakeMxBlPrContract(sushi), getMxContract(sushi), getSushiContract(sushi))
  const aliceBakePrice = usePrice(getBakeAliceBlpContract(sushi), getAliceContract(sushi), getSushiContract(sushi))
  const soccerBakePrice = usePrice(getSoccerBakeBlpContract(sushi), getSoccerContract(sushi), getSushiContract(sushi))
  const tkoBakePrice = usePrice(getTkoBakeBlpContract(sushi), getTkoContract(sushi), getSushiContract(sushi))
  const tsaBakePrice = usePrice(getTsaBakeBlpContract(sushi), getTsaContract(sushi), getSushiContract(sushi))
  const tlmBakePrice = usePrice(getTlmBakeBlpContract(sushi), getTlmContract(sushi), getSushiContract(sushi))
  const sushiPrice = usePrice(getBakeBnbBlpContract(sushi), getSushiContract(sushi), getWethContract(sushi))
  const bnrgBnbPrice = usePrice(getBnrgBnbBlpContract(sushi), getBnrgContract(sushi), getWethContract(sushi))
  const busdPrice = usePrice(getBusdBnbBlpContract(sushi), getBusdContract(sushi), getWethContract(sushi))
  const bakePetPrcie = new BigNumber(1)
  const petBnbPrice = usePrice(getPetBnbBlpContract(sushi), getPetContract(sushi), getWethContract(sushi))
  const weaponBnbPrice = usePrice(getWeaponBnbBlpContract(sushi), getWeaponContract(sushi), getWethContract(sushi))
  const xDittoBnbPrice = usePrice(getXDittoBnbBlpContract(sushi), getXDittoContract(sushi), getWethContract(sushi))
  const pokerBnbPrice = usePrice(getPokerBnbBlpContract(sushi), getPokerContract(sushi), getWethContract(sushi))
  const carBnbPrice = usePrice(getCarBnbBlpContract(sushi), getCarContract(sushi), getWethContract(sushi))
  const tlmBnbPrice = usePrice(getTlmBnbBlpContract(sushi), getTlmContract(sushi), getWethContract(sushi))
  const doggyBnbPrice = usePrice(getDoggyBnbBlpContract(sushi), getDoggyContract(sushi), getWethContract(sushi))
  const barkdoggyPrice = usePrice(getBarkDoggyBLpContract(sushi), getBarkContract(sushi), getDoggyContract(sushi))
  const bondlyBnbPrice = usePrice(getBondlyBnbBLpContract(sushi), getBondlyContract(sushi), getWethContract(sushi))
  const tokauBnbPrice = usePrice(getTokauBnbBlpContract(sushi), getTokauContract(sushi), getWethContract(sushi))
  // const levBnbPrice = usePrice(getLevBnbBlpContract(sushi), getLevContract(sushi), getWethContract(sushi))
  const tctBusdPrice = usePrice(getTctBusdBlpContract(sushi), getTctContract(sushi), getBusdContract(sushi))
  const gatBnbPrice = usePrice(getGatBnbBlpContract(sushi), getGatContract(sushi), getWethContract(sushi))
  const wsgBnbPrice = usePrice(getWsgBnbBlpContract(sushi), getWsgContract(sushi), getWethContract(sushi))
  const dogoBnbPrice = usePrice(getDogoBnbBlpContract(sushi), getDogoContract(sushi), getWethContract(sushi))
  const eggBnbPrice = usePrice(getEggBnbBlpContract(sushi), getEggContract(sushi), getWethContract(sushi))
  const kalataBnbPrice = usePrice(getKalataBnbBlpContract(sushi), getKalataContract(sushi), getWethContract(sushi))
  const donBnbPrice = usePrice(getDonBnbBlpContract(sushi), getDonContract(sushi), getWethContract(sushi))
  const ntBnbPrice = usePrice(getNtBnbBlpContract(sushi), getNtContract(sushi), getWethContract(sushi))
  const moniBnbPrice = usePrice(getMoniBnbBlpContract(sushi), getMoniContract(sushi), getWethContract(sushi))
  const kxaBnbPrice = usePrice(getKxaBnbBlpContract(sushi), getKxaContract(sushi), getWethContract(sushi))
  const nblBnbPrice = usePrice(getNblBnbBlpContract(sushi), getNblContract(sushi), getWethContract(sushi))

  const pcwsNum = useNumPool(MINTTOKEN.PCWS)
  const bryNum = useNumPool(MINTTOKEN.BRY)
  const bananaNum = useNumPool(MINTTOKEN.BANANA)
  const warNum = useNumPool(MINTTOKEN.WAR)
  const war2Num = useNumPool(MINTTOKEN.WAR2)
  const dieselNum = useNumPool(MINTTOKEN.DIESEL)
  const mxNum = useNumPool(MINTTOKEN.MX)
  const aliceNum = useNumPool(MINTTOKEN.ALICE)
  const dfyNum = useNumPool(MINTTOKEN.DFY)
  const gfxNum = useNumPool(MINTTOKEN.GFX)
  const xDittoNum = useNumPool(MINTTOKEN.XDITTO)
  const sactNum = useNumPool(MINTTOKEN.SACT)
  const pet3Num = useNumPool(MINTTOKEN.PET3)
  const hyfiNum = useNumPool(MINTTOKEN.HYFI)
  const ginuNum = useNumPool(MINTTOKEN.GINU)
  const levNum = useNumPool(MINTTOKEN.LEV)
  const bondlyNum = useNumPool(MINTTOKEN.BONDLY)
  const tctNum = useNumPool(MINTTOKEN.TCT)
  const tkoNum = useNumPool(MINTTOKEN.TKO)
  const tko2Num = useNumPool(MINTTOKEN.TKO2)
  const bnrgNum = useNumPool(MINTTOKEN.BNRG)
  const tsaNum = useNumPool(MINTTOKEN.TSA)
  const tlmNum = useNumPool(MINTTOKEN.TLM)
  const doggyTlmNum = useNumPool(MINTTOKEN.TLM2)
  const barkTlmNum = useNumPool(MINTTOKEN.TLM3)
  const tokauTlmNum = useNumPool(MINTTOKEN.TLM4)
  const bondly2Num = useNumPool(MINTTOKEN.BONDLY2)
  const gatTlmNum = useNumPool(MINTTOKEN.TLM5)
  const wsgNum = useNumPool(MINTTOKEN.WSG)
  const dogoNum = useNumPool(MINTTOKEN.DOGO)
  const bethNum = useNumPool(MINTTOKEN.BETHMASTER)
  const tokauNum = useNumPool(MINTTOKEN.TOKAU)
  const eggNum = useNumPool(MINTTOKEN.EGG)
  const kalataNum = useNumPool(MINTTOKEN.KALATA)
  const donNum = useNumPool(MINTTOKEN.DON)
  const ntNum = useNumPool(MINTTOKEN.NT)
  const moniNum = useNumPool(MINTTOKEN.MONI)
  const kxaNum = useNumPool(MINTTOKEN.KXA)
  const nblNum = useNumPool(MINTTOKEN.NBL)

  // const defi100BakePrice = usePrice(
  //   getDEFI100BakeBLPContract(sushi),
  //   getDEFI100Contract(sushi),
  //   getSushiContract(sushi)
  // )

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore

  // 获取当前质押的池子
  const fetchBakeV2Staked = useCallback(async (lpTokenAddress) => {
    let balance:any 
    let masterContract = getMasterChef2Contract(sushi)
    balance = await getStaked(masterContract, lpTokenAddress, account)
    return balance
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, getMasterChef2Contract, getStaked])

  // 只显示质押
  const [isOnlyStaked, setIsOnlyStaked] = useState<boolean>(false)
  const [farmsNew, setFarmsNew] = useState<Array<any>>(farms)
  const fetchBakeV2StakedFarms = useCallback(async () => {
    let stakedBalance = []
    let stakedV2Farms = []
    for(let i = 0;i < farms.length; i++){
      if(tokenName === MINTTOKEN.BAKEV2){
        const balance = fetchBakeV2Staked(farms[i].lpTokenAddress)
        stakedBalance.push(balance)
      }
    }

    for(let i = 0;i < stakedBalance.length;i++){
      const balanceFmt = await stakedBalance[i]
      const harvestBalanceFmt: any = getFullDisplayBalance(new BigNumber(balanceFmt))
      if(+harvestBalanceFmt){
        stakedV2Farms.push(farms[i])
      }
    }
    setIsOnlyStaked(true)
    setFarmsNew(stakedV2Farms)
  }, [account, getMasterChef2Contract, getStaked])

  const fetchBakeAllFarms = useCallback(async () => {
    setIsOnlyStaked(false)
    setFarmsNew(farms)
  }, [])

  useEffect(() => {
    setIsOnlyStaked(false)
    setFarmsNew(farms)
  }, [farms, account])


  // console.log("---farms--",farms)
  const rows = farmsNew.reduce<FarmWithStakedValue[][]>(
    (farmRows, farm) => {
      let i = -1
      let blockNum
      let stakedValue
      let apy: BigNumber | null = null
      let bethRoi
      let bakeRoi
      let ankrRoi
      let onxRoi
      let isNull = false
      
      switch (farm.tokenSymbol) {
        case MINTTOKEN.ETH2MASTER:
          stakedValue = BakeStakedValue
          blockNum = BakeBlockNum
          i = bakeFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            stakedValue[i] && blockNum && sushiPrice
              ? sushiPrice
                  .times(blockNum.times(30000)) 
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(
                    stakedValue[i].totalWethValue.comparedTo(0) <= 0
                      ? // 不要随便更换池子顺序
                        i !== usdtBusdIndex &&
                        i !== busdUsdcIndex &&
                        i !== petIndex &&
                        i !== petBakeIndex &&
                        i !== tctBusdIndex
                        ? (i !== bakeIndex ? stakedValue[i].tokenAmount : stakedValue[i].lpBalanceOfMaster).times(
                            sushiPrice
                          )
                        : i !== petIndex && i !== petBakeIndex && busdPrice
                        ? stakedValue[i].tokenAmount.times(busdPrice)
                        :  i !== petIndex
                        ? stakedValue[i].tokenAmount.times(petBnbPrice || '')
                        : stakedValue[i].lpBalanceOfMaster.times(petBnbPrice || '')
                        
                      : stakedValue[i].totalWethValue
                  )
              : null
          const lpTokenAddress = farm.lpTokenAddress.toLowerCase()
          if (ethInfo && Object.keys(ethInfo).length !== 0) {
            Object.keys(ethInfo).forEach(key => {
              if (key.toLowerCase() === lpTokenAddress) {
                const info = ethInfo[key]
                bethRoi = (+info.bethValueRoi * 2) / 100
                bakeRoi = (+info.bakeValueRoi * 2) / 100
              }
            })
          } else {
            bethRoi = 0
            bakeRoi = 0
          }
          break
        case MINTTOKEN.AETHMASTER:
          stakedValue = BakeStakedValue
          blockNum = BakeBlockNum
          i = bakeFarms.findIndex(({ pid }) => pid === farm.pid)
          isNull = true
          apy =
            stakedValue[i] && blockNum && sushiPrice
              ? sushiPrice
                  .times(new BigNumber(0)) // TODO
                  .times(blockNum.times(30000)) // TODO
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(
                    stakedValue[i].totalWethValue.comparedTo(0) <= 0
                      ? // 不要随便更换池子顺序
                        i !== usdtBusdIndex && i !== petIndex && i !== petBakeIndex
                        ? (i !== bakeIndex ? stakedValue[i].tokenAmount : stakedValue[i].lpBalanceOfMaster).times(
                            sushiPrice
                          )
                        : i !== petIndex && i !== petBakeIndex && busdPrice
                        ? stakedValue[i].tokenAmount.times(busdPrice)
                        : i !== petIndex 
                        ? stakedValue[i].tokenAmount.times(petBnbPrice || '')
                        : stakedValue[i].lpBalanceOfMaster.times(petBnbPrice || '')
                      : stakedValue[i].totalWethValue
                  )
              : null
          apy = new BigNumber(0)
          const aethlpTokenAddress = farm.lpTokenAddress.toLowerCase()
          if (aethInfo && Object.keys(aethInfo).length !== 0) {
            Object.keys(aethInfo).forEach(key => {
              if (key.toLowerCase() === aethlpTokenAddress) {
                const info = aethInfo[key]
                ankrRoi = +info.otherValueRois[0] / 100
                onxRoi = +info.otherValueRois[1] / 100
                bakeRoi = +info.bakeValueRoi / 100
              }
            })
          } else {
            ankrRoi = 0
            onxRoi = 0
            bakeRoi = 0
          }
          break
        case MINTTOKEN.PET:
          blockNum = petBlockNum || new BigNumber(0)
          stakedValue = petStakedValue
          i = petFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            stakedValue[i] && blockNum
              ? bakePetPrcie
                  .times(blockNum.times(30000))
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(stakedValue[i].tokenAmount)
              : null
          break
        case MINTTOKEN.BPET:
          blockNum = bPetBlockNum || new BigNumber(0)
          stakedValue = bPetStakedValue
          i = bPetFarms.findIndex(({ pid }) => pid === farm.pid)
          apy = new BigNumber(0)
          // apy = stakedValue[i]
          //   ? petBnbPrice
          //       .times(2000)
          //       .times(new BigNumber(365))
          //       .times(stakedValue[i].poolWeight)
          //       .div(stakedValue[i].totalWethValue)
          //   : null
          break
        case MINTTOKEN.WEAPON:
          blockNum = weaponBlockNum || new BigNumber(0)
          stakedValue = weaponStakedValue
          i = weaponFarms.findIndex(({ pid }) => pid === farm.pid)
          apy = stakedValue[i] && weaponBnbPrice && sushiPrice
            ? weaponBnbPrice
                .times(0)
                .times(250000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].lpBalanceOfMaster.times(i === weaponPoolPetIndex ? petBnbPrice || '' : sushiPrice))
            : null
          break
        case MINTTOKEN.BEST:
          blockNum = bestBlockNum || new BigNumber(0)
          stakedValue = bestStakedValue
          i = bestFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            stakedValue[i] && blockNum
              ? bakePetPrcie
                  .times(blockNum.times(30000))
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(stakedValue[i].tokenAmount)
              : null
          break
        case MINTTOKEN.TEN:
          stakedValue = tenStakedValue
          i = springFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            tenBakeBlpBalanceOfTemMaster && tenBakeBlpTenPrice
              ? new BigNumber(0)
                  .times(new BigNumber(10).pow(18))
                  .times(new BigNumber(365))
                  .div(tenBakeBlpBalanceOfTemMaster.times(tenBakeBlpTenPrice))
              : null
          break
        case MINTTOKEN.WSOTE:
          stakedValue = wSoteStakedValue
          i = wsoteFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            wSoteBakePrice && stakedValue[i]
              ? new BigNumber(0)
                  .times(new BigNumber(365))
                  .div(7)
                  .times(wSoteBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.SHIELD:
          stakedValue = shieldStakedValue
          i = shieldFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            sushiPrice && busdPrice && stakedValue[i]
              ? new BigNumber(0)
                  .times(new BigNumber(365))
                  .div(10)
                  .times(3) // 3 BUSD
                  .times(busdPrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
                  .div(sushiPrice)
              : null
          break
        case MINTTOKEN.BRY:
          stakedValue = bryStakedValue
          i = bryFarms.findIndex(({ pid }) => pid === farm.pid)
          if (bryNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            bryBakePrice && stakedValue[i]
              ? new BigNumber(2500)
                  .times(new BigNumber(365))
                  .div(14)
                  .times(bryBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.BANANA:
          stakedValue = bananaStakedValue
          i = bananaFarms.findIndex(({ pid }) => pid === farm.pid)
          if (bananaNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(7000)
                .times(new BigNumber(365))
                .div(14)
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.DEFI100:
          stakedValue = defi100StakedValue
          i = defi100Farms.findIndex(({ pid }) => pid === farm.pid)
          apy = new BigNumber(0)
          break
        case MINTTOKEN.DEFI100OLD:
          stakedValue = defi100StakedValue
          i = defi100Farms.findIndex(({ pid }) => pid === farm.pid)
          apy = new BigNumber(0)
          break
        case MINTTOKEN.PCWS:
          stakedValue = pcwsStakedValue
          i = pcwsFarms.findIndex(({ pid }) => pid === farm.pid)
          if (pcwsNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            pcwsBakePrice && stakedValue[i]
              ? new BigNumber(1717)
                  .times(new BigNumber(365))
                  .div(33)
                  .times(pcwsBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.WAR:
          stakedValue = warStakedValue
          i = warFarms.findIndex(({ pid }) => pid === farm.pid)
          if (warNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            warBakePrice && stakedValue[i]
              ? new BigNumber(0)
                  .times(new BigNumber(365))
                  .div(31)
                  .times(warBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.WAR2:
          stakedValue = war2StakedValue
          i = war2Farms.findIndex(({ pid }) => pid === farm.pid)
          if (war2Num.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(500000)
                .times(new BigNumber(365))
                .div(10)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.DIESEL:
          stakedValue = dieselStakedValue
          i = dieselFarms.findIndex(({ pid }) => pid === farm.pid)
          if (dieselNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i] && sushiPrice
            ? new BigNumber(46805)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(60)
                .div(
                  i === 0
                    ? stakedValue[i].lpBalanceOfMaster
                        .times(sushiPrice)
                        .div(stakedValue[1].totalWethValue)
                        .times(stakedValue[1].tokenAmount.times(2))
                    : stakedValue[i].tokenAmount.times(2)
                )
            : null
          break
        case MINTTOKEN.MX:
          stakedValue = mxStakedValue
          i = mxFarms.findIndex(({ pid }) => pid === farm.pid)
          if (mxNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            mxBakePrice && stakedValue[i]
              ? new BigNumber(46900)
                  .times(new BigNumber(365))
                  .div(21)
                  .times(mxBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.DFY:
          stakedValue = dfyStakedValue
          i = dfyFarms.findIndex(({ pid }) => pid === farm.pid)
          if (dfyNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(3000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.GFX:
          stakedValue = gfxStakedValue
          i = gfxFarms.findIndex(({ pid }) => pid === farm.pid)
          if (gfxNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i] && sushiPrice
            ? new BigNumber(10000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(60)
                .div(
                  i === 0 && sushiPrice
                    ? stakedValue[i].lpBalanceOfMaster
                        .times(sushiPrice)
                        .div(stakedValue[1].totalWethValue)
                        .times(stakedValue[1].tokenAmount.times(2))
                    : stakedValue[i].tokenAmount.times(2)
                )
            : null
          break
        case MINTTOKEN.HYFI:
          stakedValue = hyfiStakedValue
          i = hyfiFarms.findIndex(({ pid }) => pid === farm.pid)
          if (hyfiNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i] && sushiPrice
            ? new BigNumber(3000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(
                  i === 1
                    ? stakedValue[i].lpBalanceOfMaster
                        .times(sushiPrice)
                        .div(stakedValue[0].totalWethValue)
                        .times(stakedValue[0].tokenAmount.times(2))
                    : stakedValue[i].tokenAmount.times(2)
                )
            : null
          break
        case MINTTOKEN.GINU:
          stakedValue = ginuStakedValue
          i = ginuFarms.findIndex(({ pid }) => pid === farm.pid)
          if (ginuNum.toNumber() <= 1) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(210000)
                .times(new BigNumber(0))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(i === 1 ? stakedValue[i].lpBalanceOfMaster : stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.TOKAU:
          stakedValue = tokau2StakedValue
          i = tokauFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tokauNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(7000000000)
                .times(new BigNumber(365))
                .div(stakedValue[i].lpBalanceOfMaster)
            : null
          break
        case MINTTOKEN.LEV:
          stakedValue = levStakedValue
          i = levFarms.findIndex(({ pid }) => pid === farm.pid)
          if (levNum.toNumber() <= 1) {
            isNull = true
          }
          apy = new BigNumber(0)
          // apy = stakedValue[i] && levBnbPrice
          //   ? levBnbPrice
          //       .times(13998)
          //       .times(new BigNumber(365))
          //       .times(stakedValue[i].poolWeight)
          //       .div(stakedValue[i].totalWethValue)
          //   : null
          break
        case MINTTOKEN.BETHMASTER:
          stakedValue = bethStakedValue
          i = bethFarms.findIndex(({ pid }) => pid === farm.pid)
          if (bethNum.toNumber() <= 1) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(1)
                .times(new BigNumber(365))
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.WSG:
          stakedValue = wsgStakedValue
          i = wsgFarms.findIndex(({ pid }) => pid === farm.pid)
          if (wsgNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i] && wsgBnbPrice && gatBnbPrice && sushiPrice
            ? wsgBnbPrice
                .times(240000000000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(
                  i === 0
                    ? stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
                    : i === 1
                      ? stakedValue[i].totalWethValue
                      : stakedValue[i].lpBalanceOfMaster.times(gatBnbPrice)
                )
            : null
          break
        case MINTTOKEN.DOGO:
          blockNum = DogoBlockNum
          stakedValue = dogoStakedValue
          i = dogoFarms.findIndex(({ pid }) => pid === farm.pid)
          if (dogoNum.toNumber() === 0) {
            isNull = true
          }
          let dogoDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            dogoDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && dogoBnbPrice 
            ? dogoBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(dogoDenominator)
            : null
          break
        case MINTTOKEN.EGG:
          blockNum = EggBlockNum
          stakedValue = eggStakedValue
          i = eggFarms.findIndex(({ pid }) => pid === farm.pid)
          if (eggNum.toNumber() === 0) {
            isNull = true
          }
          let eggDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            eggDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && eggBnbPrice 
            ? eggBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(eggDenominator)
            : null
          break
        case MINTTOKEN.NT:
          blockNum = NtBlockNum
          stakedValue = ntStakedValue
          i = ntFarms.findIndex(({ pid }) => pid === farm.pid)
          if (ntNum.toNumber() === 0) {
            isNull = true
          }
          let ntDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            ntDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && ntBnbPrice 
            ? ntBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(ntDenominator)
            : null
          break
        case MINTTOKEN.MONI:
          blockNum = MoniBlockNum
          stakedValue = moniStakedValue
          i = moniFarms.findIndex(({ pid }) => pid === farm.pid)
          if (moniNum.toNumber() === 0) {
            isNull = true
          }
          let moniDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            moniDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && moniBnbPrice 
            ? moniBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(moniDenominator)
            : null
          break
        case MINTTOKEN.KXA:
          blockNum = KxaBlockNum
          stakedValue = kxaStakedValue
          i = kxaFarms.findIndex(({ pid }) => pid === farm.pid)
          if (kxaNum.toNumber() === 0) {
            isNull = true
          }
          let kxaDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            kxaDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && kxaBnbPrice 
            ? kxaBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(kxaDenominator)
            : null
          break
        case MINTTOKEN.NBL:
          blockNum = NblBlockNum
          stakedValue = nblStakedValue
          i = nblFarms.findIndex(({ pid }) => pid === farm.pid)
          if (nblNum.toNumber() === 0) {
            isNull = true
          }
          let nblDenominator = new BigNumber(0)
          if (stakedValue[i]) {
            if (i === 0) {
              nblDenominator = sushiPrice ? stakedValue[i].lpBalanceOfMaster.times(sushiPrice) : nblDenominator
            } else {
              nblDenominator = stakedValue[i].totalWethValue
            }
          }
          apy = stakedValue[i] && blockNum && nblBnbPrice 
            ? nblBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(nblDenominator)
            : null
          break
        case MINTTOKEN.KALATA:
          blockNum = KalataBlockNum
          stakedValue = kalataStakedValue
          i = kalataFarms.findIndex(({ pid }) => pid === farm.pid)
          if (kalataNum.toNumber() === 0) {
            isNull = true
          }
          let kalataDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            kalataDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && kalataBnbPrice 
            ? kalataBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(kalataDenominator)
            : null
          break
        case MINTTOKEN.DON:
          blockNum = DonBlockNum
          stakedValue = donStakedValue
          i = donFarms.findIndex(({ pid }) => pid === farm.pid)
          if (donNum.toNumber() === 0) {
            isNull = true
          }
          let donDenominator = new BigNumber(0)
          if(stakedValue[i] && sushiPrice){
            donDenominator = stakedValue[i].lpBalanceOfMaster.times(sushiPrice)
          }
          apy = stakedValue[i] && blockNum && donBnbPrice 
            ? donBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(donDenominator)
            : null
          break
        case MINTTOKEN.BONDLY:
          stakedValue = bondlyStakedValue
          i = bondlyFarms.findIndex(({ pid }) => pid === farm.pid)
          if (bondlyNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(3750)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.BONDLY2:
          stakedValue = bondly2StakedValue
          i = bondly2Farms.findIndex(({ pid }) => pid === farm.pid)
          if (bondly2Num.toNumber() === 0) {
            isNull = true
          }
          apy =
            bondlyBnbPrice && doggyBnbPrice && stakedValue[i]
              ? new BigNumber(15000)
                  .times(new BigNumber(365))
                  .times(bondlyBnbPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(doggyBnbPrice))
              : null
          break
        case MINTTOKEN.TKO:
          stakedValue = tkoStakedValue
          i = tkoFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tkoNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            tkoBakePrice && stakedValue[i]
              ? new BigNumber(300)
                  .times(new BigNumber(365))
                  .times(tkoBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.TKO2:
          stakedValue = tko2StakedValue
          i = tko2Farms.findIndex(({ pid }) => pid === farm.pid)
          if (tko2Num.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(0)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.BNRG:
          blockNum = BnrgBlockNum
          stakedValue = bnrgStakedValue
          i = bnrgFarms.findIndex(({ pid }) => pid === farm.pid)
          if (bnrgNum.toNumber() === 0) {
            isNull = true
          }
          let bnrgDenominator = new BigNumber(0)
          if(stakedValue[i]){
            // bnb lp
            if(stakedValue[i].totalWethValue.comparedTo(0) > 0){
              bnrgDenominator = stakedValue[i].totalWethValue
            } else{
              // BMON-BUSD BLP
              if(i === bmonBusdIndex && busdPrice){
                bnrgDenominator = stakedValue[i].tokenAmount
                .times(2)
                .times(busdPrice)
              }
            }
          }
          apy = stakedValue[i] && blockNum && bnrgBnbPrice 
            ? bnrgBnbPrice
                .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(bnrgDenominator)
            : null
          break
        case MINTTOKEN.TCT:
          stakedValue = tctStakedValue
          i = tctFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tctNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            sushiPrice && tctBusdPrice && stakedValue[i] && busdPrice
              ? new BigNumber(30000)
                  .times(new BigNumber(365))
                  .div(30)
                  .times(tctBusdPrice)
                  .times(busdPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(sushiPrice))
              : null
          break
        case MINTTOKEN.XDITTO:
          stakedValue = xDittoStakedValue
          i = xDittoFarms.findIndex(({ pid }) => pid === farm.pid)
          if (xDittoNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            sushiPrice && xDittoBnbPrice && stakedValue[i]
              ? new BigNumber(50000)
                  .times(new BigNumber(365))
                  .div(100)
                  .times(xDittoBnbPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(sushiPrice))
              : null
          break
        case MINTTOKEN.SACT:
          stakedValue = sactStakedValue
          i = sactFarms.findIndex(({ pid }) => pid === farm.pid)
          if (sactNum.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(100000)
                .times(new BigNumber(365))
                .div(100)
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.PET3:
          stakedValue = pet3StakedValue
          i = pet3Farms.findIndex(({ pid }) => pid === farm.pid)
          if (pet3Num.toNumber() === 0) {
            isNull = true
          }
          apy = stakedValue[i]
            ? new BigNumber(2000)
                .times(new BigNumber(365))
                .times(stakedValue[i].poolWeight)
                .div(stakedValue[i].tokenAmount.times(2))
            : null
          break
        case MINTTOKEN.ALICE:
          stakedValue = aliceStakedValue
          i = aliceFarms.findIndex(({ pid }) => pid === farm.pid)
          if (aliceNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            aliceBakePrice && stakedValue[i]
              ? new BigNumber(100)
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(stakedValue[i].tokenAmount.times(2))
              : null
          break
        case MINTTOKEN.TSA:
          stakedValue = tsaStakedValue
          i = tsaFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tsaNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            tsaBakePrice && stakedValue[i]
              ? new BigNumber(10000)
                  .times(new BigNumber(365))
                  .times(tsaBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.TLM:
          stakedValue = tlmStakedValue
          i = tlmFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tlmNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            tlmBakePrice && stakedValue[i]
              ? new BigNumber(20000)
                  .times(new BigNumber(365))
                  .times(tlmBakePrice)
                  .div(stakedValue[i].lpBalanceOfMaster)
              : null
          break
        case MINTTOKEN.TLM2:
          stakedValue = doggyStakedValue
          i = doggyTlmFarms.findIndex(({ pid }) => pid === farm.pid)
          if (doggyTlmNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            tlmBnbPrice && doggyBnbPrice && stakedValue[i]
              ? new BigNumber(5000)
                  .times(new BigNumber(365))
                  .times(tlmBnbPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(doggyBnbPrice))
              : null
          break
        case MINTTOKEN.TLM3:
          stakedValue = barkStakedValue
          i = barkTlmFarms.findIndex(({ pid }) => pid === farm.pid)
          if (barkTlmNum.toNumber() === 0) {
            isNull = true
          }
         apy =
            tlmBnbPrice && doggyBnbPrice && barkdoggyPrice && stakedValue[i]
              ? new BigNumber(5000)
                  .times(new BigNumber(365))
                  .times(tlmBnbPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(barkdoggyPrice).times(doggyBnbPrice))
              : null
          break
        case MINTTOKEN.TLM4:
          stakedValue = tokauStakedValue
          i = tokauTlmFarms.findIndex(({ pid }) => pid === farm.pid)
          if (tokauTlmNum.toNumber() === 0) {
            isNull = true
          }
          apy =
            tlmBnbPrice && tokauBnbPrice && stakedValue[i]
              ? new BigNumber(10000)
                  .times(0)
                  .times(new BigNumber(365))
                  .times(tlmBnbPrice)
                  .div(stakedValue[i].lpBalanceOfMaster.times(tokauBnbPrice))
              : null
          break
        case MINTTOKEN.TLM5:
            stakedValue = gatStakedValue
            i = gatTlmFarms.findIndex(({ pid }) => pid === farm.pid)
            if (gatTlmNum.toNumber() === 0) {
              isNull = true
            }
            apy =
              tlmBnbPrice && gatBnbPrice && stakedValue[i]
                ? new BigNumber(3000)
                    .times(new BigNumber(365))
                    .times(tlmBnbPrice)
                    .div(stakedValue[i].lpBalanceOfMaster.times(gatBnbPrice))
                : null
            break
        case MINTTOKEN.BAKEV2:
          blockNum = BakeBlockNum2
          stakedValue = BakeStakedValue2
          i = bakeV2Farms.findIndex(({ pid }) => pid === farm.pid)
          let bakeV2Denominator = new BigNumber(0)
          if(stakedValue[i]){
            // bnb lp
            if(stakedValue[i].totalWethValue.comparedTo(0) > 0){
              bakeV2Denominator = stakedValue[i].totalWethValue
            }else{
              // Bread
              if(i === bakeIndex2 && sushiPrice){
                bakeV2Denominator = stakedValue[i].lpBalanceOfMaster
                .times(sushiPrice)
              }
              // BAKE-BUSD BLP
              if(i === bakeBusdIndex2 && sushiPrice){
                bakeV2Denominator = stakedValue[i].tokenAmount.times(2)
                .times(sushiPrice)
              }
              // SOCCER
              if(i === soccerIndex2 && soccerBakePrice && sushiPrice){
                bakeV2Denominator = stakedValue[i].lpBalanceOfMaster
                .times(soccerBakePrice.times(sushiPrice))
              }
              // POKER TO BAKE
              if(i === pokerIndex2 && pokerBnbPrice){
                bakeV2Denominator = stakedValue[i].lpBalanceOfMaster
                .times(pokerBnbPrice)
              }
              // CAR TO BAKE
              if(i === carIndex2 && carBnbPrice){
                bakeV2Denominator = stakedValue[i].lpBalanceOfMaster
                .times(carBnbPrice)
              }
            }
          }
          apy =
            stakedValue[i] && blockNum && sushiPrice 
            ? sushiPrice
                  .times(blockNum.div(new BigNumber(10).pow(18)).times(30000))
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(bakeV2Denominator)
            : null
          break
        default:
          blockNum = BakeBlockNum
          stakedValue = BakeStakedValue
          i = bakeFarms.findIndex(({ pid }) => pid === farm.pid)
          apy =
            stakedValue[i] && blockNum && sushiPrice
              ? sushiPrice
                  .times(blockNum.times(30000))
                  .times(new BigNumber(365))
                  .times(stakedValue[i].poolWeight)
                  .div(
                    stakedValue[i].totalWethValue.comparedTo(0) <= 0
                      ? // 不要随便更换池子顺序
                        i !== usdtBusdIndex &&
                        i !== busdUsdcIndex &&
                        i !== barkDoggyIndex &&
                        i !== petIndex &&
                        i !== petBakeIndex &&
                        i !== soccerIndex &&
                        i !== tctBusdIndex &&
                        i !== pokerIndex &&
                        i !== carIndex &&
                        i !== tokauIndex
                        ? (i !== bakeIndex
                            ? stakedValue[i].tokenAmount.times(2)
                            : stakedValue[i].lpBalanceOfMaster
                          ).times(sushiPrice)
                        : i !== petIndex &&
                          i !== petBakeIndex &&
                          i !== soccerIndex &&
                          i !== pokerIndex &&
                          i !== carIndex &&
                          i !== tokauIndex && busdPrice
                        ? stakedValue[i].tokenAmount
                            .times(2)
                            .times(i === barkDoggyIndex ? doggyBnbPrice || new BigNumber(0) : busdPrice)
                            .times(i === busdUsdcIndex ? 3 : 1)
                        : i !== petIndex &&
                        i !== soccerIndex &&
                        i !== pokerIndex &&
                        i !== carIndex &&
                        i !== tokauIndex
                        ? stakedValue[i].tokenAmount.times(2).times(petBnbPrice || '')
                        : stakedValue[i].lpBalanceOfMaster.times(
                            i !== soccerIndex
                              ? i !== petIndex
                                ? i !== pokerIndex
                                  ? i !== carIndex
                                    ? i !== tokauIndex
                                    ? ""
                                    : tokauBnbPrice ? tokauBnbPrice : ''
                                    : carBnbPrice ? carBnbPrice : ''
                                  : pokerBnbPrice ? pokerBnbPrice : ''
                                : petBnbPrice ? petBnbPrice : ''
                              : soccerBakePrice && sushiPrice
                              ? soccerBakePrice.times(sushiPrice)
                              : ''
                          )
                      : stakedValue[i].totalWethValue
                  )
              : null
          break
      }
      const farmWithStakedValue = {
        ...farm,
        ...stakedValue[i],
        apy,
        bakeRoi,
        bethRoi,
        ankrRoi,
        onxRoi,
        isNull
      }
      const newFarmRows = [...farmRows]
      if (newFarmRows[newFarmRows.length - 1].length === 3) {
        newFarmRows.push([farmWithStakedValue])
      } else {
        newFarmRows[newFarmRows.length - 1].push(farmWithStakedValue)
      }
      return newFarmRows
    },
    [[]]
  )

  // 获取池子收割数量
  const fetchHarvestBalance = useCallback(async (lpTokenAddress) => {
    let balance:any 
    let masterContract = getMasterChef2Contract(sushi)
    balance = await getTokenEarned(masterContract, lpTokenAddress, account)
    return balance
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, getMasterChef2Contract, getTokenEarned])

  // 待收割bakev2总数
  const [harvestSum1, setHarvestSum1] = useState<any>('0')
  const [harvestList, setHarvestList] = useState<any>([])

  const fetchHarvestAll = useCallback(async() => {
    const bakeV2FarmsFilter = bakeV2Farms.filter(d => !d.ended)
    try{
      let balances=[]
      let harvestListInit = []
      let harvestSum:number = 0
      for(let i = 0;i < bakeV2FarmsFilter.length;i++){
        let lpTokenAddress = bakeV2FarmsFilter[i].lpTokenAddress
        balances.push(fetchHarvestBalance(lpTokenAddress))
      }
      for(let i=0;i<balances.length;i++){
        const harvestBalance = await balances[i]
        const harvestBalanceFmt: any = getFullDisplayBalance(new BigNumber(harvestBalance))
        if(+harvestBalanceFmt){
          harvestSum += harvestBalanceFmt * 1
          bakeV2FarmsFilter[i]["harvestBalanceFmt"] = harvestBalanceFmt
          harvestListInit.push(bakeV2FarmsFilter[i])
        }
      }
      let harvestSumFmt:string = new BigNumber(harvestSum).toFixed(3, BigNumber.ROUND_FLOOR)
      setHarvestSum1(harvestSumFmt)
      setHarvestList(harvestListInit)
    }catch (e) {
      console.log(e)
    }
  },[bakeV2Farms, fetchHarvestBalance, getFullDisplayBalance])

  useEffect(() => {
    fetchHarvestAll()
  }, [fetchHarvestAll])

  useInterval(() => {
    fetchHarvestAll()
  }, account ? 10000 : null)

  const handleHarvestAll = useCallback(
    async () => {
      let masterContract = getMasterChef2Contract(sushi)
      harvestList.map(async (d:any) => {
        let lpTokenAddress = d.lpTokenAddress
        const txHash = await harvest(masterContract, lpTokenAddress, account)
        return txHash
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [account, harvest, harvestList],
  )
  
  return (
    <>
      {
        tokenName === MINTTOKEN.BAKEV2 ? (
          <Bakev2>
            <Harvest>
              <img src="/images/192x192_App_Icon.png" width={'20px'} height={'20px'}/>
              <V2Sum>{harvestSum1}</V2Sum>
              <V2harvest>To harvest</V2harvest>
              <ButtonHarvest onClick={handleHarvestAll}>Harvest All</ButtonHarvest>
            </Harvest>
            <StakeOnly>
              <V2Text>staked only</V2Text>
              {
                !isOnlyStaked ? (
                  <img onClick={fetchBakeV2StakedFarms} src="/images/bakery/icon_close.png"/>
                ):(
                  <img onClick={fetchBakeAllFarms} src="/images/bakery/icon_open.png"/>
                )
              }
            </StakeOnly>
          </Bakev2>
        ):null
      }
      <ListWrapper>
        {!!rows[0].length ? (
          rows.map(row => {
            return row
              .filter(d => !d.ended)
              .map(d => {
                return (
                  <CurrencyCard
                    key={d.name}
                    showBorder={[
                      'BAKE',
                      'PET',
                      'PET-BNB BLP',
                      'PET-BAKE BLP',
                      'BAKE-DOGE BLP',
                      'BAKE-SHIELD BLP',
                      'BAKE-BRY BLP',
                      'BAKE-D100 BLP',
                      'BNB-D100 BLP',
                      'BAKE BANANA BLP',
                      'BNB-pCWS BLP',
                      'BAKE-WAR BLP',
                      'BUSD-WAR BLP',
                      'BNB-DIESEL BLP',
                      'pCWS',
                      'BAKE-MX BLP',
                      'BAKE-BAT BLP',
                      'BAKE-ALICE BLP',
                      'ALICE',
                      'AUTO-BNB BLP',
                      'SOCCER-BNB BLP',
                      'SOCCER',
                      'DFY-BNB BLP',
                      'DFY-BAKE BLP',
                      'GFX-BNB BLP',
                      'xDitto-BNB BLP',
                      'SACT-BAKE BLP',
                      'HYFI-BNB BLP',
                      'TCT-BUSD BLP',
                      'TKO NFT',
                      '1INCH',
                      'TKO-BUSD BLP',
                      'TKO-BNB BLP',
                      'XDITTO',
                      'POKER-BNB BLP',
                      'POKER',
                      'CAR-BNB BLP',
                      'CAR',
                      'DOGGY-BNB BLP',
                      'DOGGY',
                      'BONDLY-BNB BLP',
                      'GINU-BNB BLP',
                      'LI-BNB BLP',
                      'SI-BNB BLP',
                      'LEV-BNB BLP',
                      'GINU',
                      'BARK',
                      'BARK-DOGGY BLP',
                      'BONDLY',
                      'TOKAU',
                      'TOKAU-BNB BLP',
                      'BETH-ETH BLP',
                      'TOY NFT',
                      'GAT-BNB BLP',
                      'GAT',
                      'WSG-BNB BLP',
                      'USDT-BNB BLP',
                      'BAKE-BNB BLP',
                      'BUSD-BNB BLP',
                      'ETH-BNB BLP',
                      'BTC-BNB BLP',
                      'BAKE-BUSD BLP',
                      'BMON-BUSD BLP',
                      'BMON-BNB BLP',
                      'GENESIS NFT',
                      'EGG-BNB BLP',
                      'NBL-BNB BLP'
                    ].includes(d.symbol) && tokenName !== MINTTOKEN.BAKE && tokenName != MINTTOKEN.ENDED}
                    isCover={[MINTTOKEN.TEN].includes(d.tokenSymbol)}
                    isEndedNft={
                      (tokenName === MINTTOKEN.ALLNFT &&
                        [
                          MINTTOKEN.SEASCAPENFT,
                          MINTTOKEN.TKONFT,
                          MINTTOKEN.HATNFT,
                          MINTTOKEN.ALICENFT,
                          MINTTOKEN.ONEINCHBAKENFT,
                          MINTTOKEN.TEN,
                          MINTTOKEN.XDITTONFT,
                          MINTTOKEN.BONDLYNFT,
                          MINTTOKEN.TKONFTSTAKE,
                          MINTTOKEN.TOYNFTSTAKE,
                          MINTTOKEN.TOYNFT,
                          MINTTOKEN.BMONCNFTSTAKE
                          // MINTTOKEN.BMONCNFTSTAKE
                        ].includes(d.tokenSymbol) ||
                        tokenName === MINTTOKEN.ENDED
                      )
                    }
                    style={{
                      backgroundImage:
                        'url(/images/bakery/icon_' +
                        (/\.png/gi.test(d.icon as string)
                          ? (d.icon as string).replace('.png', '_light.png)')
                          : d.icon + '_light.svg)')
                    }}
                  >
                    {[
                      'BAKE',
                      'PET',
                      'PET-BNB BLP',
                      'PET-BAKE BLP',
                      'BAKE-DOGE BLP',
                      'BAKE-SHIELD BLP',
                      'BAKE-BRY BLP',
                      'BAKE-D100 BLP',
                      'BNB-D100 BLP',
                      'BAKE BANANA BLP',
                      'BNB-pCWS BLP',
                      'BAKE-WAR BLP',
                      'BUSD-WAR BLP',
                      'BNB-DIESEL BLP',
                      'pCWS',
                      'BAKE-MX BLP',
                      'BAKE-BAT BLP',
                      'BAKE-ALICE BLP',
                      'ALICE',
                      'AUTO-BNB BLP',
                      'SOCCER-BNB BLP',
                      'SOCCER',
                      'DFY-BNB BLP',
                      'DFY-BAKE BLP',
                      'GFX-BNB BLP',
                      'BETH-ETH BLP',
                      'xDitto-BNB BLP',
                      'SACT-BAKE BLP',
                      'HYFI-BNB BLP',
                      'TCT-BUSD BLP',
                      'TKO NFT',
                      '1INCH',
                      'TKO-BUSD BLP',
                      'TKO-BNB BLP',
                      'XDITTO',
                      'POKER-BNB BLP',
                      'POKER',
                      'CAR-BNB BLP',
                      'CAR',
                      'DOGGY-BNB BLP',
                      'DOGGY',
                      'BONDLY-BNB BLP',
                      'GINU-BNB BLP',
                      'LI-BNB BLP',
                      'SI-BNB BLP',
                      'LEV-BNB BLP',
                      'GINU',
                      'BARK',
                      'BARK-DOGGY BLP',
                      'BONDLY',
                      'TOKAU',
                      'TOKAU-BNB BLP',
                      'TOY NFT',
                      'GAT-BNB BLP',
                      'GAT',
                      'WSG-BNB BLP',
                      'USDT-BNB BLP',
                      'BAKE-BNB BLP',
                      'BUSD-BNB BLP',
                      'ETH-BNB BLP',
                      'BTC-BNB BLP',
                      'BAKE-BUSD BLP',
                      'BMON-BUSD BLP',
                      'BMON-BNB BLP',
                      'GENESIS NFT',
                      'EGG-BNB BLP',
                      'NBL-BNB BLP'
                    ].includes(d.symbol) && tokenName !== 'BAKE' && tokenName != MINTTOKEN.ENDED &&  (
                      <HighlightFlag>
                        <IconStar src={'/images/bakery/icon_star' + (theme.darkMode ? '' : '_white') + '.svg'} />
                      </HighlightFlag>
                    )}
                    <CurrencyIcon>
                      <img
                        src={'/images/bakery/icon_' + (/\.png/gi.test(d.icon as string) ? d.icon : d.icon + '.svg')}
                        style={{
                          height: [MINTTOKEN.ETH2MASTER, MINTTOKEN.AETHMASTER, MINTTOKEN.BETHMASTER].includes(d.tokenSymbol) && false
                            ? 62
                            : d.tokenSymbol === MINTTOKEN.TEN
                            ? 68
                            : 54,
                          marginBottom: [MINTTOKEN.ETH2MASTER, MINTTOKEN.AETHMASTER, MINTTOKEN.BETHMASTER].includes(d.tokenSymbol) && false ? 40 : 0,
                          marginTop: d.tokenSymbol === MINTTOKEN.TEN ? 60 : 0
                        }}
                        alt=""
                      />
                    </CurrencyIcon>
                    {[MINTTOKEN.ETH2MASTER, MINTTOKEN.TEN, MINTTOKEN.AETHMASTER, MINTTOKEN.BETHMASTER].includes(d.tokenSymbol)  && false ? null : (
                      <CurrencySymbol>
                        <Text fontSize={28} fontWeight={600}>
                          {d.name}
                        </Text>
                      </CurrencySymbol>
                    )}
                    <Detail>
                      <Text>{['BAKE', 'PET', 'TEN-BAKE', 'TEN'].includes(d.symbol) && false ? 'Stake' : 'Deposit'}:</Text>
                      <DetailVal>
                        <Text fontWeight={600} fontFamily={'Baloo Da'}>
                          {d.lpToken === 'TEN-BAKE' ? d.lpToken.replace('-', '/') : d.lpToken}
                        </Text>
                      </DetailVal>
                    </Detail>
                    <Detail>
                      <Text>Earn:</Text>
                      <DetailVal>
                        <Text fontWeight={600} fontFamily={'Baloo Da'}>
                          {d.otherName || d.tokenSymbol}
                        </Text>
                      </DetailVal>
                    </Detail>
                    {d.amountDay ? (
                      <Detail style={{ marginTop: 32 }}>
                        <Text>Amount:</Text>
                        <DetailVal>
                          <Text fontWeight={600} fontFamily={'Baloo Da'}>
                            {d.amountDay + ' ' + d.amountUnit}
                          </Text>
                        </DetailVal>
                      </Detail>
                    ) : [
                        MINTTOKEN.HELMETNFT,
                        MINTTOKEN.SEASCAPENFT,
                        MINTTOKEN.TKONFT,
                        MINTTOKEN.HATNFT,
                        MINTTOKEN.ALICENFT,
                        MINTTOKEN.BONDLYNFT,
                        MINTTOKEN.ONEINCHBAKENFT,
                        MINTTOKEN.XDITTONFT,
                        MINTTOKEN.TOYNFT
                      ].includes(d.tokenSymbol) ? (
                      <Detail style={{ marginTop: 32 }}>
                        <Text></Text>
                        <DetailVal>
                          <Text fontWeight={700} fontFamily={'Baloo Da'}></Text>
                        </DetailVal>
                      </Detail>
                    ) : (
                      <Detail style={{ marginTop: 32 }}>
                        <Text>ROI:</Text>
                        {
                          tokenName === MINTTOKEN.ENDED ? (
                            <DetailVal>
                              <Text fontWeight={700} fontFamily={'Baloo Da'}>0</Text>
                            </DetailVal>
                          ) : (
                            <DetailVal>
                              {[MINTTOKEN.ETH2MASTER].includes(d.tokenSymbol) ? (
                                <Text fontWeight={700} fontFamily={'Baloo Da'}>
                                  {ethInfo ? `${new BigNumber(d.bethRoi + d.bakeRoi).toFormat(2, BIGNUMBER_FMT)}%` : ''}
                                </Text>
                              ) : [MINTTOKEN.AETHMASTER].includes(d.tokenSymbol) ? (
                                <Text fontWeight={700} fontFamily={'Baloo Da'}>
                                  {JSON.stringify(aethInfo) !== '{}'
                                    ? `${new BigNumber(d.bakeRoi + d.ankrRoi + d.onxRoi).toFormat(2, BIGNUMBER_FMT)}%`
                                    : '30%'}
                                </Text>
                              ) : (
                                <Text fontWeight={700} fontFamily={'Baloo Da'}>
                                  {/* {
                                    d.name == 'Bread' && console.log("-------d---------",d)
                                  } */}
                                  {d.isNull
                                    ? '0'
                                    : d.apy
                                    ? !d.apy.isNaN()
                                      ? `${d.apy.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT)}%`
                                      : '-'
                                    : 'Loading ...'}
                                </Text>
                              )}
                            </DetailVal>                          )
                        }
                      </Detail>
                    )}
                    <BtnBox>
                      {d.tokenSymbol === MINTTOKEN.HATNFT ? (
                        <>
                          <HelmetImg src="/images/helmetNft/icon_helmet_btn.svg"></HelmetImg>
                          <SelectBtn as={Link} to={'/stake/XmasHat/' + d.id}>
                            Select
                          </SelectBtn>
                        </>
                      ) : [MINTTOKEN.ETH2MASTER, MINTTOKEN.AETHMASTER].includes(d.tokenSymbol) ? (
                        <>
                          <SelectBtn as={Link} to={'/eth2/' + d.tokenSymbol + '/' + d.id}>
                            Select
                          </SelectBtn>
                        </>
                      ) : d.tokenSymbol === 'TEN' ? (
                        <>
                          <SelectTenBtn
                            as={Link}
                            to={(d.symbol === 'TEN' ? '/tenstake/' : '/bakery-ten/') + d.tokenSymbol + '/' + d.id}
                          >
                            <IconBtn style={{ left: '-20px' }} src="/images/bakery/icon_red_btn.svg"></IconBtn>
                            Select
                            <IconBtn
                              style={{ right: '-8px', bottom: '-15px' }}
                              src="/images/bakery/icon_yuanbao.svg"
                            ></IconBtn>
                          </SelectTenBtn>
                        </>
                      ) : [
                          MINTTOKEN.SEASCAPENFT,
                          MINTTOKEN.TKONFT,
                          MINTTOKEN.ALICENFT,
                          MINTTOKEN.BONDLYNFT,
                          MINTTOKEN.ONEINCHBAKENFT,
                          MINTTOKEN.XDITTONFT,
                          MINTTOKEN.TOYNFT
                        ].includes(d.tokenSymbol) ? (
                        <>
                          <HelmetImg
                            bottom={
                              [MINTTOKEN.SEASCAPENFT].includes(d.tokenSymbol)
                                ? '10px'
                                : [MINTTOKEN.TKONFT].includes(d.tokenSymbol)
                                ? '30px'
                                : '40px'
                            }
                            src={'/images/bakery/icon_' + d.icon + '_btn.svg'}
                          ></HelmetImg>
                          <SelectBtn as={Link} to={'/stake/' + d.tokenSymbol + '/' + d.id}>
                            Select
                          </SelectBtn>
                        </>
                      ) : d.stakeType === 1 ? (
                        <SelectBtn as={Link} to={'/stakenft/' + d.tokenSymbol + '/' + d.id}>
                          Select nft
                        </SelectBtn>
                      ) : (
                        <SelectBtn
                          as={Link}
                          to={
                            (d.tokenSymbol === 'PETNFT' || d.tokenSymbol === MINTTOKEN.HATNFT ? '/stake/' : '/bakery/') +
                            d.tokenSymbol +
                            '/' +
                            (![MINTTOKEN.BETHMASTER].includes(d.tokenSymbol) ? d.id : d.symbol)
                          }
                        >
                          Select
                        </SelectBtn>
                      )}
                    </BtnBox>
                  </CurrencyCard>
                )
              })
          })
        ) : (
          <>
            <Nothing>
              {
                !isOnlyStaked ? (
                  <Text fontSize={42} fontFamily={'Baloo Da'} marginBottom={10} color={theme.bsText7}>
                    Coming soon ~
                  </Text>
                ):null
              }
              <img src="/images/bakery/nft_null.svg" alt="" />
            </Nothing>
          </>
        ) 
        }
      </ListWrapper>
    </>
  )
}

export default FarmCards
